import { Inject, Injectable, Optional, PLATFORM_ID, TransferState } from '@angular/core';
import { BehaviorSubject, Observable, first, of, tap } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { WebCommonConfig } from '../config/configs/web-common.config';
import { WEB_CONFIG_KEY } from '../constants/transfer-state-keys';
import { SERVER_WEBCONFIG } from '../constants/server-tokens';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private loadedConfig = new BehaviorSubject<WebCommonConfig | undefined>(undefined);

  constructor(
    private readonly http: HttpClient,
    private readonly transferState: TransferState,
    @Inject(PLATFORM_ID) private readonly platformId: any,
    @Optional() @Inject(SERVER_WEBCONFIG) private readonly serverConfig?: WebCommonConfig
  ) {}

  get config(): WebCommonConfig {
    return this.loadedConfig.value;
  }

  getConfig(): Observable<WebCommonConfig> {
    return this.loadedConfig.asObservable().pipe(
      first((config) => !!config)
    );
  }

  initAppConfig(): Observable<WebCommonConfig> {
    if (isPlatformServer(this.platformId) && this.serverConfig) {
      this.transferState.set(WEB_CONFIG_KEY, this.serverConfig);
      this.loadedConfig.next(this.serverConfig);
      return of(this.serverConfig);
    }

    if (this.transferState.hasKey(WEB_CONFIG_KEY)) {
      const config = this.transferState.get(WEB_CONFIG_KEY, {});
      this.transferState.remove(WEB_CONFIG_KEY);
      this.loadedConfig.next(config);
      return of(config);
    }

    return this.http.get<WebCommonConfig>('/config').pipe(
      tap((config) => this.loadedConfig.next(config))
    );
  }
}
